import base from '../../../site.config';

const config = {};

config.TABLE = {};

export default { ...config, ...base };
